import * as React from 'react';
import { cn } from '@/lib/utils';

export const Input = React.forwardRef<HTMLInputElement, React.InputHTMLAttributes<HTMLInputElement>>(
  ({ className, ...props }, ref) => (
    <input
      ref={ref}
      className={cn(
        // --border-strong, not --border: 1.4.11 wants the edge that *identifies*
        // a control to clear 3:1, which a hairline divider colour does not.
        'flex h-9 w-full min-w-0 rounded-md border border-[var(--border-strong)] bg-[var(--card)] px-2.5 py-1.5 text-sm text-[var(--foreground)]',
        'placeholder:text-[var(--muted-foreground)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--ring)]',
        'disabled:cursor-not-allowed disabled:opacity-50',
        className,
      )}
      {...props}
    />
  ),
);
Input.displayName = 'Input';
